import { TeacherCommunicationsPage } from "@/features/teachers/TeacherCommunicationsPage";

export function TeacherNotesPage() {
  return <TeacherCommunicationsPage />;
}
